import fetch from '@/plugin/axios'

// 新增海报图
export function getAddPoster (query) {
  return fetch({
    url: '/api/order/poster/add',
    method: 'Post',
    data: query
  })
}

// 海报列表
export function getPosterList (query) {
  return fetch({
    url: '/api/order/poster/list',
    method: 'Post',
    data: query
  })
}

// 海报信息
export function getPosterInfo (id) {
  return fetch({
    url: `/api/order/poster/info/${id}`,
    method: 'Get'
  })
}

// 修改海报
export function getAddPosterUpdate (id, query) {
  return fetch({
    url: `/api/order/poster/update/${id}`,
    method: 'Post',
    data: query
  })
}
